export default __webpack_public_path__ + "static/Energy-2758ebeed5279e526d43cc19617e1a0b.webp";